import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { RichTextSection } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  involved_in: {
    id: 'involved_in',
    defaultMessage: 'Si occupa di',
  },
});

const IndirizzoSiOccupaDi = ({ content }) => {
  const intl = useIntl();
  return content.involved_in?.length > 0 ? (
    <>
      <RichTextSection
        tag_id="involved_in"
        title={intl.formatMessage(messages.involved_in)}
      >
        {content.involved_in?.length > 1 ? (
          <ul>
            {content.involved_in.map((el) => {
              return <li>{el.title}</li>;
            })}
          </ul>
        ) : (
          <>{content.involved_in[0].title}</>
        )}
      </RichTextSection>
    </>
  ) : (
    <></>
  );
};

export default IndirizzoSiOccupaDi;
